export default __webpack_public_path__ + "static/landscapes-first-5716d4ba740127615d7cce7a1133d40b.webp";